import * as React from 'react';
import { Input as BaseInput } from '@mui/base/Input';
import styles from './style.module.scss';

type OTPProps = {
  separator: React.ReactNode;
  length: number;
  value: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
};

function OTP({ separator, length, value, onChange }: OTPProps) {
  const inputRefs = React.useRef<(HTMLInputElement | null)[]>([]);

  const focusInput = (index: number) => {
    inputRefs.current[index]?.focus();
  };

  const selectInput = (index: number) => {
    inputRefs.current[index]?.select();
  };

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    const key = event.key;
    if (['ArrowUp', 'ArrowDown', ' '].includes(key)) event.preventDefault();
    if (key === 'ArrowLeft' && index > 0) {
      event.preventDefault();
      focusInput(index - 1);
      selectInput(index - 1);
    }
    if (key === 'ArrowRight' && index < length - 1) {
      event.preventDefault();
      focusInput(index + 1);
      selectInput(index + 1);
    }
    if (key === 'Delete' || key === 'Backspace') {
      event.preventDefault();
      if (key === 'Backspace' && index > 0) {
        focusInput(index - 1);
        selectInput(index - 1);
      }
      onChange(prev => prev.slice(0, index) + prev.slice(index + 1));
    }
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const val = event.target.value.replace(/\D/g, ''); // Only digits
    const lastChar = val.slice(-1);
    const otpArray = value.split('');
    otpArray[index] = lastChar;
    onChange(otpArray.join(''));

    if (lastChar && index < length - 1) {
      focusInput(index + 1);
    }
  };

  const handleClick = (
    _: React.MouseEvent<HTMLInputElement>,
    index: number,
  ) => {
    selectInput(index);
  };

  const handlePaste = (
    event: React.ClipboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    event.preventDefault();
    const pasted = event.clipboardData.getData('text/plain').trim().replace(/\D/g, '').slice(0, length);
    const otpArray = value.split('');

    for (let i = index; i < length && i - index < pasted.length; i++) {
      otpArray[i] = pasted[i - index];
    }

    onChange(otpArray.join(''));
  };

  return (
    <div className={styles.otpContainer}>
      {Array.from({ length }).map((_, i) => (
        <React.Fragment key={i}>
          <BaseInput
            slots={{ input: 'input' }}
            slotProps={{
              input: {
                ref: (el: HTMLInputElement | null) => {
                  inputRefs.current[i] = el;
                },
                className: `${styles.inputElement} main-font  mohave`,
                onKeyDown: (e) => handleKeyDown(e, i),
                onChange: (e) => handleChange(e, i),
                onClick: (e) => handleClick(e, i),
                onPaste: (e) => handlePaste(e, i),
                value: value[i] ?? '',
                maxLength: 2,
              },
            }}
            aria-label={`Digit ${i + 1} of OTP`}
          />
          {i < length - 1 && separator}
        </React.Fragment>
      ))}
    </div>
  );
}

export default OTP;
